import { createClient } from "@supabase/supabase-js";

const metaEnv = (import.meta as ImportMeta & { env?: { VITE_SUPABASE_URL?: string; VITE_SUPABASE_ANON_KEY?: string } })
  .env;

const supabaseUrl =
  metaEnv?.VITE_SUPABASE_URL ??
  (typeof process !== "undefined" ? process.env.VITE_SUPABASE_URL : undefined);
const supabaseAnonKey =
  metaEnv?.VITE_SUPABASE_ANON_KEY ??
  (typeof process !== "undefined" ? process.env.VITE_SUPABASE_ANON_KEY : undefined);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing Supabase environment variables. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env",
  );
}

/** Same URL/key passed to `createClient` — available for callers that need the project root URL or anon key. */
export const SUPABASE_BROWSER_URL = supabaseUrl;
export const SUPABASE_BROWSER_ANON_KEY = supabaseAnonKey;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export default supabase;
